module.exports = __webpack_public_path__ + "static/img/170810-feature-plasma-dna-Screening.5649ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-feature-plasma-dna-Screening.jpg
// module id = uCud
// module chunks = 0